import { createComponent } from '@carvana/merch-components';
import ShareIcon from '~/icons/Share';

export const BannerContainer = createComponent('div', {
  className: `
    fixed
    top-0
    z-10
    flex
    h-0
    w-full
    max-w-[1800px]
    -translate-y-full
    transform
    items-center
    justify-between
    bg-blue-5
    transition-transform
    duration-500
    ease-in-out
    s:h-[52px]
    s:px-12
    m:h-[84px]
    m:px-32
  `
});

export const ShareButton = createComponent(ShareIcon, {
  className: `w-24 text-white`
});
